<template>
  <div class="menu-settings cmsc-page-wrapper">
    <div class="cmsc-page-header">
      <h2 class="cmsc-page-title theme-border-primary-color">自定义菜单</h2>
    </div>
    <p class="tips">
      请将你想查看的菜单从左侧的“可选择菜单”栏拖入到右侧的“自定义菜单”栏
    </p>
    <div class="menu-content">
      <MenuBuilder
        :alternative-menus="alternativeMenus"
        :selected-menus="selectedMenus"
      ></MenuBuilder>
    </div>
    <div class="footer-handles">
      <Button class="handle-item" type="primary" @click="onSaveHandler"
        >保存</Button
      >
      <Button class="handle-item" @click="onResetDefault">恢复默认</Button>
    </div>
  </div>
</template>
<script>
import MenuBuilder from './Builder'
export default {
  name: '/settings/menuManage',
  components: {
    MenuBuilder
  },
  data() {
    return {
      timer: null,
      customMenus: [],
      alternativeMenus: [], // 备选菜单
      selectedMenus: [] // 选中的菜单
    }
  },
  created() {
    this.getAlternativeMenus()
    this.selectedMenus = JSON.parse(
      JSON.stringify(this.$store.state.main.menus.selected)
    )
  },
  methods: {
    getAlternativeMenus() {
      this.$http
        .get('/sctm/userprivilages/getUserObjectMenu')
        .then(({ data }) => {
          this.alternativeMenus = data.beans
          this.$store.commit('main/menus/setAlternativeMenus', data.beans)
        })
    },
    onSaveHandler() {
      this.$http
        .post('/sctm/menu/userMenuTree', { data: this.selectedMenus })
        .then(({ data }) => {
          if (data.returnCode === 0) {
            this.$Message.success('自定义菜单树保存成功')
            this.$http
              .get('/sctm/userprivilages/getUserCustomMenu')
              .then(res => {
                this.$store.commit('main/menus/setSelectedMenus', res.data.beans)
              })
          } else {
            this.$Message.error(data.returnMessage)
          }
        })
    },
    onResetDefault() {
      this.getAlternativeMenus()
      this.selectedMenus = JSON.parse(
        JSON.stringify(this.$store.state.main.menus.selected)
      )
    }
  }
}
</script>
<style lang="stylus">
.menu-settings
  height 100%
  display flex
  flex-flow column

  .tips
    font-size 16px
    flex 0 0 16px
    margin-bottom 25px

  .menu-content
    display flex
    flex auto
    height 0

    .menu-list-wrapper
      position relative
      width 0
      flex 0 0 284px
      height 100%
      margin-right 24px
      padding-top 30px
      padding-bottom 12px

      .menu-title
        position absolute
        left 0
        top 0
        font-size 16px

  .footer-handles
    margin-top 15px

    .handle-item
      margin-right 10px
</style>